module.exports = __webpack_public_path__ + "img/visa.dd264980.png";